import { RootState } from '@reducers';

export const selectGeneralPolicyDetails = (state: RootState) => state.userDashboardRouteReducer.policyDetailsReducer.generalPolicyDetailsReducer;
